import { useContext } from "react";
import PlmControlContext, { PlmControlContextType } from "./PlmControlContext";

export default function usePlmControlContext(): PlmControlContextType {
    const ctx = useContext(PlmControlContext) as PlmControlContextType;
    if (ctx === null) throw new Error('No PlmControlContext provided');
    return ctx;
}